import { em } from 'polished'
import styled, { css } from 'styled-components'

import DynamicImage from 'components/DynamicImage'
import { Text, H1Small as H1 } from 'styles/components/typography'

const boxMaxHeightMd = em(306)
const boxMaxHeightLg = em(360)
const boxPriceHeightLg = em(270)

export const Wrapper = styled.div`
  padding-bottom: ${em(60)};
  position: relative;

  ${p => p.theme.mq.upMd} {
    padding-bottom: 0;
  }
`

export const Inner = styled.div`
  display: grid;
  grid-template-areas:
    'box'
    'description'
    'price';
  background: ${p => (p.withBg ? p.theme.colors.grayOp06NonTransp : null)};
  border-radius: ${p => p.theme.blocks.blockBorderRadiusMedium};
  text-align: center;

  ${p => p.theme.mq.upMd} {
    text-align: left;
    grid-template-areas:
      'box description'
      'price';
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr auto;
  }

  ${p => p.theme.mq.upLg} {
    grid-template-areas: 'box description price';
    grid-template-columns: 50% 30% 20%;
    grid-template-rows: 1fr;
  }
`

export const TextStyled = styled(Text)`
  display: none;

  ${p => p.theme.mq.upMd} {
    display: block;
  }
`

export const ContentWrapper = styled.div`
  text-align: center;
  padding: 0 ${p => p.theme.indents.baseIndentXs};

  ${p => p.theme.mq.upMd} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: ${boxMaxHeightMd};
    text-align: left;
    padding-left: ${p => p.theme.indents.baseIndentXs};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${boxMaxHeightLg};
    justify-content: space-around;
  }

  ${TextStyled} {
    color: ${p =>
      p.isTextWhite ? p.theme.colors.white : p.theme.colors.blackOp4};
  }

  ${H1} {
    color: ${p => (p.isTextWhite ? p.theme.colors.white : null)};
  }
`

export const ButtonWrapper = styled.div`
  transform: translateY(50%);

  ${p => p.theme.mq.upMd} {
    transform: translateY(0);
  }
`

export const RightBlock = styled.div`
  ${p => p.theme.mq.upMd} {
    grid-column: 1/3;
    padding-top: ${em(50)};
  }

  ${p => p.theme.mq.upLg} {
    grid-area: price;
    align-self: center;
    height: ${boxPriceHeightLg};
    text-align: center;
    padding-top: 0;
  }
`

export const CostStockWrapper = styled.div``

export const RightBlockInner = styled.div`
  ${p => p.theme.mq.upLg} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  ${CostStockWrapper} {
    color: ${p => (p.isWhite ? p.theme.colors.white : null)};
  }
`

export const Bacteria = styled.img`
  display: none;
  pointer-events: none;

  ${p => p.theme.mq.upMd} {
    display: block;
    position: absolute;
    top: 47%;
    left: 26%;
    width: 72%;
    min-width: ${em(550)};
    transform: translate(-50%, -74%);

    ${({ isRu }) =>
      isRu &&
      css`
        width: 36%;
        min-width: auto;
        max-width: ${em(300)};
        transform: translate(-70%, -76%);
      `}
  }

  ${p => p.theme.mq.upLg} {
    width: 67%;
    top: 50%;
    left: 20%;
    transform: translate(-43%, -59%);

    ${({ isRu }) =>
      isRu &&
      css`
        width: 28%;
        max-width: none;
        transform: translate(-50.3%, -55.5%);
      `}
  }
`

export const BoxWrapper = styled.div`
  overflow: hidden;
  ${({ productType }) =>
    productType === 'wgs' &&
    css`
      transform: translateX(${em(-7)});
    `}
  ${p => p.theme.mq.upMd} {
    overflow: visible;
    grid-area: box;
    align-self: center;
    justify-self: center;

    ${({ productType }) =>
      productType === 'wgs' &&
      css`
        width: 110%;
        margin-right: ${em(60)};
        transform: none;
      `}

    ${({ productType }) =>
      productType !== 'wgs' &&
      css`
        width: 83%;
      `}
  }

  ${p => p.theme.mq.upLg} {
    ${({ productType }) =>
      productType === 'wgs' &&
      css`
        width: 100%;
      `}
  }
`

export const UpsaleBox = styled(DynamicImage)`
  position: relative;
  pointer-events: none;
  margin-bottom: ${em(30)};
  backface-visibility: hidden;
  max-width: ${em(400)};

  ${p => p.theme.mq.upMd} {
    max-width: none;
    margin-bottom: 0;
  }

  ${({ productType }) =>
    productType === 'wgs' &&
    css`
      padding: 6.5% 0.84% 5.5% 6.5%;
    `}

  ${({ isRu, productType }) =>
    productType === 'dna' &&
    !isRu &&
    css`
      width: 70%;
      ${p => p.theme.mq.upMd} {
        width: 100%;
      }
    `}

  ${({ isRu, productType }) =>
    productType === 'biome' &&
    !isRu &&
    css`
      ${p => p.theme.mq.upMd} {
        width: 160%;
        left: -29%;
      }
      ${p => p.theme.mq.upLg} {
        width: 150%;
        left: -26%;
      }
    `}

  ${({ productType, isRu }) =>
    productType === 'biome' &&
    isRu &&
    css`
      left: 9%;
      ${p => p.theme.mq.upMd} {
        left: 5%;
        width: 120%;
      }

      ${p => p.theme.mq.upLg} {
        width: 100%;
        left: 7%;
      }
    `}
`
